import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import OTPVerification from "./OTPVerification";
import { useAxios, useAlert } from "../../hooks";
import MobileNumberInput from "./MobileNumberInput";
import { SubheaderSection } from "./../../components";
import Error from "../Error/Error";
import EventBookingSuccess from "../Success/EventBookingSuccess";
import { signInMember } from "../../redux/slices/memberSlice";
import icon from "./assests/icon.svg";
import ResendOTPButton from "./../../components/ResendOTPButton";

const MobileVerification = ({
  selectedOption,
  numberOfInputs = 4,
  setProcced,
}) => {
  const axios = useAxios();
  const { alert } = useAlert();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { eventID } = useParams();

  const [loading, setLoading] = useState(false);
  const [userConsent, setUserConsent] = useState(1);
  const [eventDetail, setEventDetail] = useState(false);
  const [bannerImage, setBannerImage] = useState("");
  const [whatsappCheck, setWhatsappCheck] = useState(true);
  const [otp, setOTP] = useState(new Array(numberOfInputs).fill(""));
  const [mobileNumberOtpGenrated, setMobileNumberOtpGenrated] = useState(false);
  const [mobileNumber, setMobileNumber] = useState(
    sessionStorage.getItem("mobile") ? sessionStorage.getItem("mobile") : ""
  );

  const [otpMatch, setOTPMatch] = useState(true);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleOtpGoBack = () => {
    setMobileNumberOtpGenrated(false);
  };

  const handleUserConsentChange = (event) => {
    const isChecked = event.target.checked;

    const consentValue = isChecked ? "1" : "0";
    setUserConsent(consentValue);
  };

  const handleOTPSubmit = () => {
    const otpString = otp.join("");
    const numericOtpString = otpString.replace(/\D/g, "");
    const numericOtp = parseInt(numericOtpString, 10);

    if (isNaN(numericOtp) || numericOtpString.length !== 4) {
      dispatch(
        alert({
          type: "error",
          message: "Invalid OTP. Please enter a 4-digit numeric code.",
        })
      );
      return;
    }

    setLoading(true);

    axios({
      url: `event/booking/verify-otp?mobile_no=91${mobileNumber}&otp=${numericOtp}`,
      method: "POST",
    })
      .then((response) => {
        if (response.status) {
          axios({
            url: `notification/chrome_notification/update-user-token`,
            method: "POST",
            data: {
              token: sessionStorage.getItem("token"),
              visitor_id: response.data?._id,
            },
          });

          dispatch(
            signInMember({
              authToken: response.data.auth_token,
              ID: response.data._id,
            })
          )
            .then(() => {
              setLoading(false);
              localStorage.setItem("mobileNumber", "91" + mobileNumber);
              if (
                sessionStorage.getItem("previousPage") == "/login" ||
                !sessionStorage.getItem("previousPage")
              ) {
                navigate(pages.home.route);
              } else {
                navigate(sessionStorage.getItem("previousPage"));
              }
            })
            .catch((error) => {
              setLoading(false);
              console.error("Error during signInMember dispatch:", error);
            });
        } else {
          setOTPMatch(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setOTPMatch(false);
        console.error("Error sending OTP:", error);
      });
  };

  const handleResendOTP = () => {
    setLoading(true);
    setOTP(new Array(numberOfInputs).fill(""));
    axios({
      url: `event/booking/resend-otp?mobile_no=91${mobileNumber}`,
      method: "POST",
    })
      .then((response) => {
        if (response.status) {
          dispatch(
            alert({
              type: "success",
              message: response.message.displayMessage,
            })
          );

          setMobileNumberOtpGenrated(true);
        }
      })
      .catch((error) => {
        console.error("Error sending OTP:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleGetOTP = () => {
    setOTP(new Array(numberOfInputs).fill(""));
    setLoading(true);

    if (eventID !== "bookappointment") {
      axios({
        url:
          "event/visitor/check-booking?event_id=" +
          eventID +
          "&mobile_number=91" +
          mobileNumber,
        disableRedirect: true,
        disableAlert: false,
      })
        .then((response) => {
          if (response.status) {
            if (response.data.length > 0) {
              if (response.data[0].payment_status === "Pending") {
                navigate(
                  pages.EventBooking.route +
                    "/" +
                    response.data[0]?.event_id +
                    "/" +
                    response.data[0]?._id,
                  {
                    state: {
                      userData: response.data,
                    },
                  }
                );
              }

              if (response.data[0].payment_status === "Completed") {
                navigate(
                  pages.EventSummary.route +
                    response.data[0].event_id +
                    "/" +
                    response.data[0]._id,
                  {
                    state: {
                      userData: response.data,
                    },
                  }
                );
              }

              setLoading(false);
            } else {
              setOTP(new Array(numberOfInputs).fill(""));
              setLoading(true);

              axios({
                url: `event/booking/send-otp?mobile_no=91${mobileNumber}`,
                method: "POST",
              })
                .then((response) => {
                  if (response.status) {
                    dispatch(
                      alert({
                        type: "success",
                        message: response.message.displayMessage,
                      })
                    );
                    setMobileNumberOtpGenrated(true);
                  }
                  setLoading(false);
                })
                .catch((error) => {
                  console.error("Error sending OTP:", error);
                  setLoading(false);
                })
                .finally(() => {
                  setLoading(false);
                });
            }
          } else {
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error, "error");
        });
    } else {
      axios({
        url: `event/booking/send-otp?mobile_no=91${mobileNumber}`,
        method: "POST",
      })
        .then((response) => {
          if (response.status) {
            dispatch(
              alert({
                type: "success",
                message: response.message.displayMessage,
              })
            );
            setMobileNumberOtpGenrated(true);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error sending OTP:", error);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (eventID && eventID !== "bookappointment") {
      axios({
        url: "admin/events/event-details?event_id=" + eventID,
        method: "GET",
        customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
      }).then((response) => {
        if (response.status) {
          response?.data?.button_color &&
            sessionStorage.setItem("buttonColor", response.data.button_color);
          response?.data?.background_color &&
            sessionStorage.setItem(
              "buttonBackground",
              response.data.background_color
            );
          setEventDetail(response.data);
        }
      });
    }
  }, []);

  return (
    <Fragment>
      <Grid container flexDirection={"column"}>
        <Grid item container className="eventImageBox">
          <div style={{ width: "100%", position: "fixed", overflow: "hidden" }}>
            <img src={icon} style={{ width: "100%", height: "40vh" }} />
          </div>
        </Grid>

        {mobileNumberOtpGenrated ? (
          <Grid item padding={"0px"}>
            <Grid item container justifyContent={"center"}>
              <Grid
                item
                md={12}
                sl={6}
                zIndex={99999}
                marginTop={"30vh"}
                sx={{
                  alignContent: "center",
                  width: "100%",
                  padding: "0px 25px",
                  height: "64vh",

                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Grid item container justifyContent={"center"}>
                  <SubheaderSection
                    textAlign="start"
                    title="Enter OTP"
                    content={`sent to +91 <b> ${mobileNumber}</b>`}
                  />

                  <OTPVerification
                    handleOtpGoBack={handleOtpGoBack}
                    loading={loading}
                    otpLength={numberOfInputs}
                    onSubmit={handleOTPSubmit}
                    onResend={handleResendOTP}
                    setOTP={setOTP}
                    otp={otp}
                    otpMatch={otpMatch}
                    setOTPMatch={setOTPMatch}
                  />
                </Grid>

                <Grid item container>
                  <ResendOTPButton
                    onClick={handleResendOTP}
                    disabled={loading}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid item padding={"0px"}>
            <Grid item container justifyContent={"center"}>
              <Grid
                item
                md={12}
                sl={6}
                zIndex={99999}
                marginTop={"22vh"}
                sx={{
                  alignContent: "center",
                  width: "100%",
                  padding: "0px 25px",
                  height: "64vh",

                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Grid
                  item
                  container
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  <SubheaderSection
                    textAlign="start"
                    title="Login to Digipass"
                    content={`Enter your mobile number to receive a verification code and proceed with your ${
                      eventID === "bookappointment" ? "appointment" : "booking"
                    }.`}
                  />

                  <MobileNumberInput
                    handleGoBack={handleGoBack}
                    handleUserConsentChange={handleUserConsentChange}
                    loading={loading}
                    onSubmit={handleGetOTP}
                    setMobileNumber={setMobileNumber}
                    mobileNumber={mobileNumber}
                    whatsappCheck={whatsappCheck}
                    setWhatsappCheck={setWhatsappCheck}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

export default MobileVerification;
